import gql from "graphql-tag";

import { FRAGMENT_USER_ALL_FIELDS } from "../../../graphql/gqlFragments";

export const CREATE_USER = gql`
  mutation createUser(
    $login: String!
    $role: String!
    $password: String!
    $passwordConfirmation: String!
    $brokerName: String!
    $licence: String!
    $filters: [SearchHash!]
    $propertyTypeId: ID
    $tcpaAccepted: Boolean!
  ) {
    signUp(
      login: $login
      role: $role
      password: $password
      passwordConfirmation: $passwordConfirmation
      brokerName: $brokerName
      licence: $licence
      filters: $filters
      propertyTypeId: $propertyTypeId
      tcpaAccepted: $tcpaAccepted
    ) {
      user {
        id
        email
        phone
        # firstName
        # lastName
      }
    }
  }
`;

export const CHECK_USER_LOGIN = gql`
  query checkLogin($login: String!) {
    checkLogin(login: $login) {
      isExist
    }
  }
`;

// export const CONFIRM_USER_EMAIL = gql`
//   mutation sendUserToken($confirmationToken: String!) {
//     confirmUserEmail(confirmationToken: $confirmationToken) {
//       user {
//         ...UserAllFields
//       }
//       accessToken
//       needRedirect
//     }
//   }
//   ${FRAGMENT_USER_ALL_FIELDS}
// `;

export const CONFIRM_USER_EMAIL = gql`
  mutation confirmUserEmail($confirmationToken: String!) {
    confirmUserEmail(confirmationToken: $confirmationToken) {
      user {
        ...UserAllFields
      }
      accessToken
      needRedirect
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const RESENT_CONFIRMATION_TOKEN = gql`
  mutation sendNewConfirmationToken($email: String!) {
    resendConfirmationToken(email: $email) {
      status
    }
  }
`;

export const UPDATE_PROFILE = gql`
  mutation updateProfile($firstName: String!, $lastName: String) {
    updateProfile(firstName: $firstName, lastName: $lastName) {
      user {
        ...UserAllFields
      }
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const CONFIRM_USER_PHONE = gql`
  mutation confirmUserPhone($phone: String!, $pin: String!) {
    confirmUserPhone(phone: $phone, pin: $pin) {
      user {
        id
        email
        phone
        firstName
        lastName
        brokerName
        licence
        role
      }
      accessToken
    }
  }
`;

export const RESENT_PHONE_PIN = gql`
  mutation resendConfirmationPin($phone: String!) {
    resendConfirmationPin(phone: $phone) {
      status
    }
  }
`;

export const SIGN_IN = gql`
  mutation signIn($login: String!, $password: String!) {
    signIn(login: $login, password: $password) {
      user {
        ...UserAllFields
      }
      accessToken
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const GET_USER = gql`
  query getUser {
    getUser {
      ...UserAllFields
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const SEND_RESET_TOKEN = gql`
  mutation sendResetToken($email: String!) {
    sendResetToken(email: $email) {
      status
    }
  }
`;

export const RESET_PASSWORD_EMAIL = gql`
  mutation resetPasswordByToken(
    $resetPasswordToken: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    resetPasswordByToken(
      resetPasswordToken: $resetPasswordToken
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      user {
        ...UserAllFields
      }
      accessToken
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const SEND_RESET_PIN = gql`
  mutation sendResetPin($phone: String!) {
    sendResetPin(phone: $phone) {
      status
    }
  }
`;

export const CHECK_RESET_PASSWORD_PIN = gql`
  query checkResetPasswordPin($phone: String!, $resetPasswordPin: String!) {
    checkResetPasswordPin(phone: $phone, resetPasswordPin: $resetPasswordPin) {
      isExist
    }
  }
`;

export const RESET_PASSWORD_PHONE = gql`
  mutation resetPasswordByPin(
    $resetPasswordPin: String!
    $phone: String!
    $password: String!
    $passwordConfirmation: String!
  ) {
    resetPasswordByPin(
      resetPasswordPin: $resetPasswordPin
      phone: $phone
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      user {
        ...UserAllFields
      }
      accessToken
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const SOCIAL_AUTH = gql`
  mutation socialAuth(
    $provider: String!
    $accessToken: String!
    $role: String!
    $licence: String!
    $brokerName: String!
    $filters: [SearchHash!]
    $propertyTypeId: ID
  ) {
    socialAuth(
      provider: $provider
      accessToken: $accessToken
      role: $role
      licence: $licence
      brokerName: $brokerName
      filters: $filters
      propertyTypeId: $propertyTypeId
    ) {
      user {
        ...UserAllFields
      }
      accessToken
    }
  }
  ${FRAGMENT_USER_ALL_FIELDS}
`;

export const SIGN_OUT = gql`
  mutation signOut {
    signOut {
      status
    }
  }
`;

export const REMOVE_ID_DOCUMENT = gql`
  mutation agentDocuments($id: ID!, $removeFile: Boolean!) {
    agentDocuments(id: $id, removeFile: $removeFile) {
      agentDocument {
        id
      }
    }
  }
`;
